export default {"src":"/_next/static/media/webflow.c31af408.svg","height":72,"width":103,"blurWidth":0,"blurHeight":0};